import { storeMixin, storeGenerator } from '@/storeMixin'
import { merge } from 'lodash'

const projecttype = merge(storeMixin.getMixin(), {
  state: {
    apiUrl: '/api/v1/project/{profile}/project-type',
    app: 'project'
  }
})

const TYPES = (() =>
  merge(
    storeGenerator(
      { profile: 'GENERIC', app: 'project', model: 'projecttype' }
    ),
    { }
  )
)()

export { projecttype, TYPES }
